import React from 'react'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import CardIcon from "components/Card/CardIcon.jsx";
import Pagination from 'components/Pagination/Pagination.jsx';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import classNames from 'classnames';
import tableActions from "assets/jss/material-dashboard-pro-react/views/tableActions";

//icons
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";

// @material-ui/core components
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
class Actions extends React.Component {
  constructor(props){
    super(props)
    this.state={
      limit:this.props.limit
    }
  }
  limit(e){
    if(typeof this.props.onLimitation==='function')
    this.props.onLimitation(e.target.value)
    this.setState({
      ...this.state,
      limit:e.target.value
    })
  }
  render() {
    const {classes, actions, icon, pagination,onPagination,limitOptions,title} = this.props;
    let pages = [];
    if (pagination) {

      if (pagination.current > 1) {
        pages.push({text: <FirstPage/>,value:1});
        pages.push({
          text: pagination.current - 1,
          value:pagination.current -1
        });
      }
      pages.push({text: pagination.current, active: true});
      if (pagination.current < pagination.pages) {
        pages.push({
          text: pagination.current + 1,
          value:pagination.current+1
        });
        pages.push({
          text: <LastPage/>,
          value:pagination.pages
        
        });
      }
    }
    return <div className={classes.cardIconTitle}>
      <Toolbar
        className={classNames(classes.root, {
        [classes.highlight]: this.props.dark
      })}>
        <GridContainer >
          <GridItem xs={1} sm={1}>
            {icon
              ? <CardIcon color="rose" className={classes.icon}>
                  {icon}
                </CardIcon>
              : ''
            }
          </GridItem>
          <GridItem xs={12} sm={8} md={3}>
            {title}
          </GridItem>
          <GridItem xs={12} sm={8} md={3}>
            <div className={classes.pagination}>
              {pagination
                ? <Pagination onClick={onPagination} pages={pages}/>
                : ''}
            </div>
          </GridItem>
          <GridItem xs={12} sm={3} md={5}>

                <div className={classes.actions}>
          {this.props.onLimitation?
                  <Select value={this.state.limit} onChange={(e)=>this.limit(e)} className={classes.limitation}>
                    {limitOptions.map(e=><MenuItem key={e} value={e}>{e}</MenuItem>)}
                  </Select>

          :''}
                  {actions
                    ? Object
                    .keys(actions)
                    .map(e => (actions[e]
                      ? <Tooltip key={e} title={e} >{actions[e]}</Tooltip>
                      : ''))
                      : ''}

                </div>
          </GridItem>

        </GridContainer>
      </Toolbar>

    </div>
  }
}

export default withStyles(tableActions)(Actions)


// WEBPACK FOOTER //
// ./src/views/Tables/Actions.jsx